export default function Certificacion() {
    return (
    <div className='w-full bg-card border rounded-lg p-6'>
        <iframe 
                title="BMP_1" 
                width="1024" 
                className="w-full"
                height="1060" 
                src="https://app.powerbi.com/view?r=eyJrIjoiMDMyOTk1MWUtYzU3MS00ZGY5LTlkZGUtZDg2OTYzZjAxOTQ1IiwidCI6ImMwNGJiMGI4LTNlZTItNDlhNS1iYWE0LTFmNGQwYWM4NWE2YyIsImMiOjl9&pageName=c980e2647e8581d8ac49"
                frameBorder="0" 
                allowFullScreen={true}
        ></iframe>
    </div>
    )
}